export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7735.316f5aab.jpg";